export const TRAINING_STATUSES = ['draft', 'published', 'archived'] as const;
export type TrainingStatus = (typeof TRAINING_STATUSES)[number];

/*
  «Изображение» стоит рядом с текстом, а не внутри него.

  Картинка была довеском к текстовому блоку — и значит, её нельзя было поставить
  ни без текста, ни двумя подряд, ни над текстом. Иллюстрация к тексту у блока
  осталась (сказка сектора — это текст вместе со своей сценой), но картинка сама
  по себе теперь отдельный блок.
*/
export const TRAINING_BLOCK_TYPES = [
  'text',
  'image',
  'video',
  'audio',
  'external_link',
  'pdf',
] as const;
export type TrainingBlockType = (typeof TRAINING_BLOCK_TYPES)[number];

export const TRAINING_BLOCK_LABELS: Record<TrainingBlockType, string> = {
  text: 'Текст',
  image: 'Изображение',
  video: 'Видео',
  audio: 'Аудио',
  external_link: 'Внешняя ссылка',
  pdf: 'PDF',
};
